import store from "@/store";

export default [
	{
		path: 'chapters/:index(\\d+)',
		async beforeEnter(to, from, next) {
			await store.dispatch("game/chapters/activate", { index: parseInt(to.params.index) });
			next({ path: "/game/budget" });
		},
	},
	{
		path: 'chapters/complete',
		async beforeEnter(to, from, next) {
			store.dispatch("global/analytics/trackEvent", { ec: "In Game", ea: "Chapter Score", el: store.getters["game/scores/averaged"] });
			const path = store.getters["game/chapters/hasNextChapter"] ? "/game/chapters/next" : "/game/complete";
			next({ path });
		},
	},
	{
		path: 'chapters/next',
		async beforeEnter(to, from, next) {
			const index = store.getters["game/chapters/nextIndex"];
			next({ path: `/game/chapters/${index}` });
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/chapters.routes.js